import { getState, getStore } from "../../../store/configureStore";
import * as securityActions from "../../../actions/securityActions";
import { showToastrError } from "../../../util/toastr";
import * as messages from "../../../constants/ToastrConstants";

export default class SupportSpoVlaMedewerkerPageHelper {
    constructor(context, redirector) {
        this.context = context;
        this.redirector = redirector;
    }

    accountIdChange(event) {
        const accountId = event.target.value;

        this.context.setState({
            accountId
        });
    }

    organisatieTypeChange(event) {
        const organisatieType = event.target.value;

        this.context.setState({
            organisatieType
        });
    }

    search(accountId, organisatieType) {
        let error = null;

        if (!accountId) {
            error = "Het account ID is verplicht";

            showToastrError(messages.MESSAGE_VALIDATION_ERRORS);
            this.context.setState({
                error
            });

            return;
        }

        if (!accountId.replace(/[/\\.\s+-]/g, "").trim().match("(^([0-9A-Fa-f]{8}[0-9A-Fa-f]{4}[0-9A-Fa-f]{4}[0-9A-Fa-f]{4}[0-9A-Fa-f]{12})$)")) {
            error = "Het account ID is ongeldig.";

            showToastrError(messages.MESSAGE_VALIDATION_ERRORS);
            this.context.setState({
                error
            });

            return;
        }

        const store = getStore();

        store.dispatch(securityActions.authorizeSpoVlaMedewerker(accountId.replace(/[/\\.\s+-]/g, "").trim(), organisatieType)).then(() => {
            const state = getState();

            if (state?.security?.error) {
                this.context.setState({
                    error: state.security.error
                });

                return;
            }

            if (!state?.security?.accountId || !state?.security?.roles) {
                return;
            }

            const isOrganisator = state.security.roles.isOrganisator;
            const isBeoordelingGemeente = state.security.roles.isBeoordelingGemeente;
            const isBeoordelingFedOrKoepel = state.security.roles.isBeoordelingFedOrKoepel;

            if (isOrganisator) {
                this.redirector.goTo("/e-loket/veldtoertochten");
            } else if (isBeoordelingGemeente) {
                this.redirector.goTo("/e-loket/gemeente/veldtoertochten");
            } else if (isBeoordelingFedOrKoepel) {
                this.redirector.goTo("/e-loket/federatieOverzicht");
            } else {
                this.redirector.goTo('/noAccess');
            }
        });
    }
}
